// ============================================================
// CLUBHUB – Nachrichten: wie lang ist eine SMS?
// ============================================================
// Eine SMS fasst 160 Zeichen aus dem GSM-Zeichensatz. Steht auch
// nur EIN Zeichen ausserhalb darin („, –, ein Emoji), geht die ganze
// Nachricht als Unicode und fasst 70. Laengere Nachrichten werden in
// Teile zerlegt (153 bzw. 67 Zeichen je Teil, der Rest traegt die
// Klammer, die sie beim Empfaenger wieder zusammensetzt).
//
// Der Zaehler im Editor sagt deshalb nicht nur „143 Zeichen“,
// sondern auch, WELCHES Zeichen die Nachricht auf Unicode zwingt —
// meist ein typografisches Anfuehrungszeichen aus einer Vorlage.
// ============================================================

const GSM_BASIS = new Set(
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà",
);
/** Zaehlen doppelt (Escape-Zeichen davor). */
const GSM_ERWEITERT = new Set("^{}\\[~]|€\f");

export type SmsLaenge = {
  zeichen: number;
  teile: number;
  unicode: boolean;
  /** Zeichen je Teil bei dieser Laenge. */
  proTeil: number;
  /** Wie viele Zeichen in den aktuellen Teil noch passen. */
  frei: number;
  /** Die Zeichen, die Unicode erzwingen. */
  fremd: string[];
};

export function smsLaenge(text: string): SmsLaenge {
  const fremd = new Set<string>();
  let einheiten = 0;
  for (const z of text) {
    if (GSM_BASIS.has(z)) einheiten += 1;
    else if (GSM_ERWEITERT.has(z)) einheiten += 2;
    else fremd.add(z);
  }
  const unicode = fremd.size > 0;
  if (unicode) {
    // UTF-16: ein Emoji belegt zwei Einheiten.
    const laenge = text.length;
    const teile = laenge <= 70 ? 1 : Math.ceil(laenge / 67);
    const proTeil = teile === 1 ? 70 : 67;
    return { zeichen: laenge, teile: Math.max(1, teile), unicode, proTeil, frei: teile * proTeil - laenge, fremd: [...fremd] };
  }
  const teile = einheiten <= 160 ? 1 : Math.ceil(einheiten / 153);
  const proTeil = teile === 1 ? 160 : 153;
  return { zeichen: einheiten, teile: Math.max(1, teile), unicode, proTeil, frei: Math.max(1, teile) * proTeil - einheiten, fremd: [] };
}

